import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/home/user1/contest.qingmaoedu.com/learning_center.qingmaoedu.com/layouts/default.vue").then(m => m.default || m))
}